import script from "./DocumentActionMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentActionMenu.vue?vue&type=script&setup=true&lang=js"

import "./DocumentActionMenu.vue?vue&type=style&index=0&id=0146f0a6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0146f0a6"]])

export default __exports__